/**
 * Sanitize heading text for use in element IDs.
 * Produces URL-safe slugs from heading text.
 *
 * Transforms:
 * - Converts to lowercase
 * - Replaces non-alphanumeric characters with hyphens
 * - Removes leading/trailing hyphens
 * - Truncates to 50 characters
 *
 * @param text - The heading text to sanitize
 * @returns A URL-safe slug suitable for use in element IDs
 *
 * @example
 * sanitizeHeadingText("Hello World!") // "hello-world"
 * sanitizeHeadingText("Section 1.2: Overview") // "section-1-2-overview"
 */
export function sanitizeHeadingText(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 50);
}
